import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ServiceSyncWatingV2Item from './ServiceSyncWatingV2Item';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
  itemName?: string;
  duration?: number;
  staffName?: string;
  remove?: (name: number) => void;
  fieldName: number;
  staffAvatar?: string;
  uniqueId?: string;
};

const SortableItem = ({
  value,
  onChange,
  itemName,
  duration,
  staffName,
  remove,
  fieldName,
  staffAvatar,
  uniqueId,
}: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: uniqueId || '',
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <ServiceSyncWatingV2Item
        value={value}
        itemName={itemName}
        duration={duration}
        staffName={staffName}
        staffAvatar={staffAvatar}
        fieldName={fieldName}
        remove={remove}
        onChange={onChange}
      />
    </div>
  );
};

export default SortableItem;
